// extracted by mini-css-extract-plugin
module.exports = {"link":"Logo_link__dhs_1","logo":"Logo_logo__tyKDe","logo_mobile":"Logo_logo_mobile__FLOLQ"};